import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { RouterModule, RouterLink } from '@angular/router';
import { MatToolbarModule } from '@angular/material/toolbar';
import { NotLoggedHeaderComponent } from '../not-logged-header/not-logged-header.component';
import { NavmenuComponent } from '../navmenu/navmenu.component';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [CommonModule, MatToolbarModule, RouterModule, RouterLink, NotLoggedHeaderComponent, NavmenuComponent],
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent {
  constructor(private router: Router) {}

  // Verifica se o usuário está na rota inicial
  isNotLogged(): boolean {
    return this.router.url === '/';
  }


  canShow(): boolean {
    return this.router.url !== '/login' && this.router.url !== '/signup' && !this.router.url.startsWith('/exam') && !this.router.url.startsWith('/question/') && !this.router.url.startsWith('/terms');
  }
}
